<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Logs de inicio de sesión</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="imprimirExcel" id="excel" class="btn-success">
            <i class="fa fa-file-excel-o" aria-hidden="true"></i><span>Excel</span>
          </button>
          <button type="button" @click="consultar" id="consultar" class="btn-info btn--bigger">
            <i class="fa fa-search" aria-hidden="true"></i><span>Consultar</span>
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-7">
            <div class="form-inline">
              <label>
                <p><strong>Fecha:</strong></p>
              </label>
              <label>
                <input name="tipo_fecha" v-model="form.tipo_fecha" type="radio" value="H">
                <span>Hoy</span>
              </label>
              <label>
                <input name="tipo_fecha" v-model="form.tipo_fecha" type="radio" value="A">
                <span>Ayer</span>
              </label>
              <label>
                <input name="tipo_fecha" v-model="form.tipo_fecha" type="radio" value="P">
                <span>Personalizado</span>
              </label>
              <div class="form-field" v-show="form.tipo_fecha === 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.fecha_desde"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Desde</label>
                </div>
              </div>
              <div class="form-field" v-show="form.tipo_fecha === 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="hasta"
                    v-model="form.fecha_hasta"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Hasta</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-5">
            <div class="form-group select2">
              <div class="select2-field">
                <v-select multiple v-model="usuariosSeleccionados" id="usuarios" placeholder="Seleccione..." v-show="!form.todos_usuarios"
                  :options="usuarios" label="nombre">
                </v-select>
                <label for="usuarios">Usuarios:</label>
              </div>
              <label for="todos_usuarios">
                <input type="checkbox" v-model="form.todos_usuarios" id="todos_usuarios">
                <span>Todos</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <vue-good-table 
              :columns="[
                {
                  label: 'FECHA',
                  field: 'fecha'
                },
                {
                  label: 'NOMBRE',
                  field: 'nombre_persona'
                },
                {
                  label: 'USUARIO',
                  field: 'nombre_usuario'
                },
                {
                  label: 'IP',
                  field: 'ip'
                }
              ]"
              :pagination-options="{
                enabled: true,
                perPage: 20,
                perPageDropdown: [],
                nextLabel: 'siguiente',
                prevLabel: 'anterior',
                rowsPerPageLabel: 'Registros por página',
                ofLabel: 'de',
                allLabel: 'Todo',
                dropdownAllowAll: true
              }"
              :rows="registros"
              :search-options="{
                enabled: true,
                placeholder: 'Buscar...'
              }"
              styleClass="vgt-table vgt-table--sticky"
            >
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      registros: [],
      usuarios: [],
      usuariosSeleccionados: [],
      form: {
        tipo_consulta: 'C',
        tipo_fecha: 'H',
        fecha_desde: moment(new Date()).format('YYYY-MM-DD'),
        fecha_hasta: moment(new Date()).format('YYYY-MM-DD'),
        idsUsuarios: [],
        todos_usuarios: true
      }
    }
  },
  watch: {
    'form.fecha_desde' : function(value){
      if(value!=null && value!=undefined){
        if(value.length == 10){
          let date = new Date(value);
          if(date == 'Invalid Date'){
            swal('Error','La fecha inicial es incorrecta','error');
            this.form.fecha_desde = null;
          }
        }
      }
    },
    'form.fecha_hasta' :  function(value){
      if(value!=null && value!=undefined){
        if(value.length == 10){
          let date = new Date(value);
          if(date == 'Invalid Date'){
            swal('Error','La fecha final es incorrecta','error');
            this.form.fecha_hasta = null;
          }
        }
      }
    },
    usuariosSeleccionados: function(){
      this.form.idsUsuarios.splice(0, this.form.idsUsuarios.length);
      for(let i=0; i<this.usuariosSeleccionados.length; i++){
        this.form.idsUsuarios.push(this.usuariosSeleccionados[i].id);
      }
    }
  },
  methods: {
    consultar: function(){
      if(this.validarFiltros()){
        let that = this;
        let urlApi = url + '/logs-login/consultar';
        this.form.tipo_consulta = 'C';
        axios.get(urlApi, {
          params: this.form
        }).then(function (response) {
          that.registros = JSON.parse(JSON.stringify(response.data));
        }).catch(function(error) {
          swal('Error', 'No se pudo consultar los logs, intente nuevamente', 'error');
        });
      }
    },
    imprimirExcel: function(){
      if(this.validarFiltros()){
        this.form.tipo_consulta = 'E';
        let queryString = this.serialize(this.form);
        let urlApi = url + '/logs-login/consultar' + queryString;
        window.open(urlApi, '_blank');
      }
    },
    serialize : function ( obj ) {
      return '?' + Object.keys(obj).reduce(function(a,k){
        let val = obj[k];
        if (val instanceof Date)
          val = val.toLocaleDateString('en');
        else if (val === undefined || val === null)
          val = '';
        a.push(k + '=' + encodeURIComponent(val));
        return a;
      },[]).join('&')
    },
    validarFiltros: function(){
      if(this.form.tipo_fecha == 'P'){
        if(this.form.fecha_desde == null || this.form.fecha_hasta == null){
          swal('Aviso','Debe ingresar las fechas','warning');
          return false;
        }
        else if(this.form.fecha_desde.length != 10 || this.form.fecha_hasta.length != 10){
          swal('Aviso','Debe ingresar las fechas de manera correcta','warning');
          return false;
        }
      } 
      if(!this.form.todos_usuarios && this.form.idsUsuarios.length == 0){
        swal('Aviso','Debe seleccionar al menos un usuario','warning');
        return false;
      }     
      return true;
    }
  },
  mounted: function(){
    document.querySelector('title').text ='Logs Login';
    let that = this;
    let urlApi = url + '/logs-login/cargar-formulario';
    axios.get(urlApi).then(function (response) {
      that.usuarios = JSON.parse(JSON.stringify(response.data.usuarios));
    }).catch(function(error) {
      swal('Error', 'No se cargaron los usuarios en la pantalla', 'error');
    });
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/LogsLogin.vue